<template>
  <div class="flex flex-col pl-2">
    <div class="relative">
      <h2 class="p-2 text-center text-6pt font-bold capitalize">
        {{ $t("legal_text.toc") }}
      </h2>
      <div class="absolute right-0 top-1.5 flex items-center gap-1">
        <button
          v-tooltip.bottom="t('collapse')"
          class="size-6 rounded p-1 transition hover:bg-gray-300"
          :class="{ 'bg-gray-300': openState === 'closed' }"
          @click="closeAllTabs"
        >
          <span class="sr-only">{{ t("collapse") }}</span>
          <i-ri-menu-fold-2-line class="h-full w-full" />
        </button>
        <button
          v-tooltip.bottom="t('expand')"
          class="size-6 rounded p-1 transition hover:bg-gray-300"
          :class="{ 'bg-gray-300': openState === 'open' }"
          @click="openAll"
        >
          <span class="sr-only">{{ t("expand") }}</span>
          <i-ri-menu-unfold-2-line class="h-full w-full" />
        </button>
      </div>
    </div>
    <ul ref="legalTextTocSub" class="list-none overflow-y-auto pb-4 pr-3">
      <li
        v-for="legalText in toc"
        :key="legalText.id"
        class="my-1"
        @click="toggleCollapse"
        @keyup.enter="toggleCollapse"
      >
        <LegalTextDisclosure
          :legalTextSlug="legalTextSlug"
          :legalTextToc="legalText"
          :tocOverviewParagraph="lastOpenedParagraph"
          :parentsOfActiveParagraph="parentsOfOpenedParagraph"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { IToC } from "~/models/IToC";
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

const { t } = useI18n({ useScope: "local" });

const props = defineProps<{
  toc: IToC[];
  flatToc: (IToC | ILegalTextParagraph)[];
  legalTextSlug: string;
  tocOverviewParagraph?: ILegalTextParagraph;
}>();

const legalTextTocSub = ref();

const lastOpenedParagraph = ref(props.tocOverviewParagraph);

const closeAllTabs = () => {
  lastOpenedParagraph.value = undefined;
  closeAll();
};

const { closeAll, openAll, toggleCollapse, openState } = useLegalTextDisclosure(
  legalTextTocSub,
  !!props.tocOverviewParagraph
);

const parentsOfOpenedParagraph = computed(() =>
  parentsOfParagraph(props.flatToc, props.tocOverviewParagraph?.slug)
);
</script>
<i18n>
  {
    "de": {
      "collapse": "Alle Überschriften einklappen",
      "expand": "Alle Überschriften ausklappen"
    },
    "en": {
      "collapse": "Collapse all headings",
      "expand": "Expand all headings"
    }
  }
</i18n>
